import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Button, Typography} from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LinearProgress, {linearProgressClasses} from '@mui/material/LinearProgress';
import {styled} from '@mui/material/styles';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import Divider from '@mui/material/Divider';
import * as util from "../utils/util";
import GaugeChart from "./GaugeChart";
import api from "../utils/api";

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetBlood = {
  bloodSugarMorning: 0,
  bloodSugarMorningAfter: 0,
  bloodSugarLunch: 0,
  bloodSugarLunchAfter: 0,
  bloodSugarDinner: 0,
  bloodSugarDinnerAfter: 0,
  bloodSugarSleep: 0
}

const HistoryBloodInputCard = (props: any) => {
  const navigate = useNavigate();
  const [dayValue, setDayValue] = useState(0);
  const [targetBlood, setTargetBlood] = React.useState(initTargetBlood);
  
  useEffect(() => {
    setBloodData();
  }, []);

  function setBloodData() {
    // 혈압 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_016?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetBlood(res.data.result_data.target);
      }
    }).catch(function (error) {
      console.log(error)
    });
  }
  
  function getTitleForTargetBlood(targetBlood :any) {
    const historyCount = getBorderProgressValue(targetBlood);
    if(historyCount === 0){
      return '오늘 혈당을 측정하지 않으셨습니다.';
    }else if(historyCount < 7){
      return '오늘 ' + historyCount + '번 측정하셨습니다.';
    }else {
      return '오늘 혈당 수치 측정 완료!';
    }
  }
  
  function getBorderProgressValue(targetBlood :any) {
    return (Object.values(targetBlood).filter((value :any) => value > 0).length);
  }
  
  

  return (
    <Box alignItems="flex-start" sx={Card_Style} >

      <Typography sx={{ textAlign: 'center', fontSize: 14, fontWeight: 700, p: '15px 0 15px 0' }}>오늘 혈당 수치</Typography>
      <Divider />
      <Box sx={{ p: 0.5 }}>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <Box>
            <GaugeChart targetValue={util.getPressureStatusAndColor(util.getLatestValue(targetBlood).type, util.getLatestValue(targetBlood).bloodValue).gaugeValue} />
            
            <Typography component={'div'} sx={{ width: '100%', textAlign: 'center', color: util.getPressureStatusAndColor(util.getLatestValue(targetBlood).type, util.getLatestValue(targetBlood).bloodValue).color, fontSize: 16, fontWeight: 700, }}>
              {util.getPressureStatusAndColor(util.getLatestValue(targetBlood).type, util.getLatestValue(targetBlood).bloodValue).status}
            </Typography>
          </Box>

            <Button onClick={() => {navigate('../history/Blood')}} sx={{ flexWrap: 'wrap', p: 0, py:1 }}>
              <Stack direction={'row'} alignItems={'baseline'}>
                <Typography sx={{ color: '#555', fontSize: 22, pr: '5px', fontWeight: 700 }}>{util.getLatestValue(targetBlood).bloodValue}</Typography>
                <Typography sx={{ color: '#888', fontSize: 14, textTransform: 'none' }}>mg/dL</Typography>
              </Stack>
            </Button>
      
          <Box sx={{ pb: 2 }}>
            <Button onClick={() => {navigate('../history/Blood')}} sx={{ p: 0, border: '1px solid #EF8322', borderRadius: 5 }}>
              <EditNoteRoundedIcon sx={{ ml: 1, color: '#EF8322' }} />
              <Typography sx={{ color: '#EF8322', fontSize: 14, pr: 1, fontWeight: 700, pl: .5 }}>입력하기</Typography>
            </Button>
          </Box>
        </Stack>
        <Divider />
        <Box sx={{ p: 0.5, }}>
          <Typography sx={{ fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 32, color: '#555' }}> {getTitleForTargetBlood(targetBlood)}</Typography>
        </Box>
      </Box>

      <BorderLinearProgress variant="determinate" value={Math.round( getBorderProgressValue(targetBlood) / 7 * 100)}
        sx={{ borderRadius: '0 0 20px 20px', bgcolor: '#eaeaea' }}
      />
    </Box>
  );
  {/* <ListItem alignItems="flex-start" sx={Card_Style} >
          <ListItemAvatar>
              <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
          </ListItemAvatar>
          <ListItemText
          primary ={title} 
          secondary={
              <Box>
                  <Box>{props.values.kcal} {props.values.unitType} 
                      <Button onClick={props.values.navi}>
                          <ModeIcon />
                      </Button>
                  </Box>
                  {props.values.emptyText}
                  <LinearProgress variant="determinate" value={progress} />
              </Box>
          }
          >
          </ListItemText>
      </ListItem> 
  );*/}
}

const BorderLinearProgress = styled(LinearProgress)({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#eaeaea',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#ff816d',
  },
});

const Card_Style = {
  borderRadius: '10px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',

  flex: '0 50%',
  maxWidth: '100%'
};

export default HistoryBloodInputCard;